/**
 * @file upp-konva-host-area.ts
 * @brief Derivatives from the host **`upp-konva`** tied to the **`UppKonvaArea`** contract and theme (without mutating the model).
 *
 * @details
 * English comment normalized.
 * (`model.area`, `model.mode` as VIEW or EDIT, `area.mode` as SHAPES or VERTEX).
 */

import type { UppFloorPlanTheme } from '../plan/floor-plan-theme';
import type { UppKonvaFloorPlanModel } from '../internal/upp-konva-floor-plan-model';

/**
 * @brief Resolves the partial theme that the internal stage should receive.
 *
 * @param themeInput Value of the `@Input` **`theme`**: **`undefined`** uses the model's theme; **`null`** clears override;
 *   English comment normalized.
 * @param modelTheme Theme stored in {@link UppKonvaFloorPlanModel.theme} (can be `undefined`).
 * English comment normalized.
 */
export function resolveUppKonvaHostTheme(
  themeInput: Partial<UppFloorPlanTheme> | null | undefined,
  modelTheme: Partial<UppFloorPlanTheme> | null | undefined,
): Partial<UppFloorPlanTheme> | null {
  if (themeInput !== undefined) {
    return themeInput;
  }
  return modelTheme ?? null;
}

/**
 * Room background pointer mode state.
 *
 * @details With {@link UppKonvaFloorPlanModel.mode} **EDIT** and {@link UppKonvaArea.mode} **VERTEX**, the stage enables
 * English comment normalized.
 * of the wiring of the selector **`upp-konva`**.
 *
 * @param model Live model linked to the component.
 */
export function uppKonvaHostStageRoomBackgroundPointerMode(
  model: UppKonvaFloorPlanModel,
): 'none' | 'doubleClickRoomCm' {
  return model.mode === 'EDIT' && model.area.mode === 'VERTEX' ? 'doubleClickRoomCm' : 'none';
}
